module.exports = __webpack_public_path__ + "media/images/city/024-notre-dame-5135beccb1053104a91542420f482a2b.svg";